import { SET_LANGUAGE_START } from '../types';

export const setLanguage = (payload) => ({
  type: SET_LANGUAGE_START,
  payload,
});
